export const API_URL = process.env.REACT_APP_API_URL as string;

// REACT_APP_* é embutida pelo CRA no momento do build (Dockerfile-Dev/Stg/Prod),
// diferente de NODE_ENV, que o react-scripts força para "production" em qualquer
// `yarn build` — por isso é essa a variável confiável para diferenciar ambientes
// publicados (ver isDev em utils/isDev).
export const APP_ENV = process.env.REACT_APP_ENV ?? "production";

// Conta pagadora dos arquivos de remessa CNAB 240 (conta da DocttorPay
// no Sicredi). Configurada via .env — REACT_APP_CNAB_PAYER_*.
export const CNAB_PAYER = {
  cnpj: process.env.REACT_APP_CNAB_PAYER_CNPJ ?? "",
  name: process.env.REACT_APP_CNAB_PAYER_NAME ?? "DOCTTORPAY",
  agency: process.env.REACT_APP_CNAB_PAYER_AGENCY ?? "",
  agencyDv: process.env.REACT_APP_CNAB_PAYER_AGENCY_DV ?? " ",
  account: process.env.REACT_APP_CNAB_PAYER_ACCOUNT ?? "",
  accountDv: process.env.REACT_APP_CNAB_PAYER_ACCOUNT_DV ?? " ",
  conventionCode: process.env.REACT_APP_CNAB_PAYER_CONVENTION ?? "",
};
